import numeral from 'numeral';
import CommunitiesCommunityFilter from './filters/Communities/Community';

const config = {
  builder_id: '5eb58c8d4db0482923f41573',
  auth_domain: 'mrn-homes.com',
  entity_logos: {
    plan: 'elevationPhotos[0]',
    community: 'logo',
    home: 'photos[0]',
  },
  mapbox: {
    key: 'pk.eyJ1IjoiYnVpbGRlcmRlc2lnbnMiLCJhIjoiY2ptMHNiMXA0MmZ1ODNwcDQ3a29zczNwcCJ9.4WUKLamqBrnJTCtMgXViJA',
  },
  social_links: {
    facebook: '/images/icon-facebook.svg',
    instagram: '/images/icon-instagram.svg',
    youtube: '/images/icon-youtube.svg',
    pinterest: '/images/icon-pinterest.svg',
    twitter: '/images/icon-twitter.svg',
    houzz: '/images/icon-houzz.svg',
    linkedin: '/images/icon-linkedin.svg',
    googleplus: '/images/icon-google.svg',
    fallback: '/images/icon-baths.svg',
  },
  filters: {
    all: {
      Area: {
        routeParam: 'communityMarketArea',
      },
      Price: {
        labelRender: ({ value }) => `${numeral(value.start).format('$0,0')} - ${numeral(value.end).format('$0,0')}`,
      },
    },
    communities: {
      Community: CommunitiesCommunityFilter,
    },
  },
};

export default config;



// WEBPACK FOOTER //
// ./src/configuration.js